import React from 'react';

export interface BasureroIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const BasureroIcon: React.FC<BasureroIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g filter="url(#a)"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.75 8.667h1.959m0 0h15.668m-15.668 0v13.71a1.96 1.96 0 0 0 1.958 1.959h9.793a1.96 1.96 0 0 0 1.958-1.959V8.667m-10.772 0V6.71a1.96 1.96 0 0 1 1.959-1.959h3.917a1.96 1.96 0 0 1 1.959 1.959v1.958"/></g><defs><filter id="a" width="32" height="32" x="-2.437" y="-1.457" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"/><feBlend in2="BackgroundImageFix" mode="overlay" result="effect1_dropShadow_285_44319"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feGaussianBlur stdDeviation=".5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="effect1_dropShadow_285_44319" mode="multiply" result="effect2_dropShadow_285_44319"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_285_44319" result="shape"/></filter></defs>
    </svg>
  );
};

export default BasureroIcon;
